import React from "react";
import { useUscLabel, useUscOptionalLabel } from "../../../../utils/labels";
import { MODAL_CONTENT } from "../../../../../../common-deprecated/utils/modalConstants";
import { showModal } from "../../../../../../common-deprecated/redux/actions/ModalActions";
import { useUscDispatch } from "../../../../redux/store";
import ServicesCard from "../../styles/molecules/ServicesCard";
import Button from "../../../../../shared-components/toyota/styles/atoms/Button";
import Text from "../../../../../shared-components/toyota/styles/atoms/Text";
import { useComponentRegistry } from "../../componentRegistry";

/**
 * The warranty service is only shown when the vehicle has a warranty.
 * This is based on the 'vehicleHasWarranty' util inside 'getEnabledServices'
 * Therefor the warranty will currently always be shown as included
 */
const WarrantyService = (): JSX.Element => {
    const dispatch = useUscDispatch();

    const [titleLabel, includedLabel, showMoreModalTitleLabel] = useUscLabel([
        "uscServicesWarrantyTitle",
        "uscServicesIncluded",
        "uscServicesWarrantyShowMoreModalTitle",
    ]);
    const [descriptionLabel, freeLabel, showMoreCtaLabel, showMoreModalBodyLabel] = useUscOptionalLabel([
        "uscServicesWarrantyDescription",
        "uscServicesWarrantyFree",
        "uscServicesWarrantyShowMoreCta",
        "uscServicesWarrantyShowMoreModalBody",
    ]);

    const showMoreInfoModal = showMoreCtaLabel && showMoreModalTitleLabel && showMoreModalBodyLabel;

    const ServicesCardFooter = useComponentRegistry("ServicesCardFooter");

    return (
        <ServicesCard
            icon="warranty"
            title={titleLabel}
            descriptionLabel={descriptionLabel}
            showMoreInfoModal={showMoreInfoModal}
            showMoreInfoOnclick={() => {
                dispatch(
                    showModal({
                        type: MODAL_CONTENT,
                        title: showMoreModalTitleLabel,
                        content: showMoreModalBodyLabel,
                    }),
                );
            }}
            showMoreInfoButtonLabel={showMoreCtaLabel}
            role="option"
            isActive
        >
            <ServicesCardFooter>
                <div>
                    <Text tag="span" variant="body-semibold">
                        {freeLabel}
                    </Text>
                </div>
                <Button variant="pack" disabled>
                    {includedLabel}
                </Button>
            </ServicesCardFooter>
        </ServicesCard>
    );
};

export default WarrantyService;
